import React, { useEffect } from 'react';

const A2WPage = ({ user }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="max-w-4xl mx-auto py-12 px-6">
      <h1 className="text-3xl font-bold text-gray-800 mb-2">A2W - Amazon to Walmart Flips</h1>
      <p className="text-gray-500 mb-8">Watch this:</p>

      <div className="rounded-2xl overflow-hidden shadow-lg bg-black" style={{ aspectRatio: '16/9' }}>
        <iframe
          width="100%"
          height="100%"
          src="https://www.youtube.com/embed/fZ3Gql0NqgI"
          title="A2W - Amazon to Walmart Flips"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
          allowFullScreen
          style={{ display: 'block', width: '100%', height: '100%', minHeight: 400 }}
        />
      </div>
    </div>
  );
};

export default A2WPage;